/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_ErrorInputs */

const en_admin_ai_chat_error = /** @type {(inputs: Admin_Ai_Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not get a reply. Try again.`)
};

const de_admin_ai_chat_error = /** @type {(inputs: Admin_Ai_Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwort konnte nicht abgerufen werden. Versuche es erneut.`)
};

const es_admin_ai_chat_error = /** @type {(inputs: Admin_Ai_Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo obtener una respuesta. Inténtalo de nuevo.`)
};

const fr_admin_ai_chat_error = /** @type {(inputs: Admin_Ai_Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'obtenir une réponse. Réessayez.`)
};

const nl_admin_ai_chat_error = /** @type {(inputs: Admin_Ai_Chat_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon geen antwoord ophalen. Probeer het opnieuw.`)
};

/** @type {(inputs: Admin_Ai_Chat_ErrorInputs) => LocalizedString} */
const it_admin_ai_chat_error = en_admin_ai_chat_error;

/** @type {(inputs: Admin_Ai_Chat_ErrorInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_error = en_admin_ai_chat_error;

/** @type {(inputs: Admin_Ai_Chat_ErrorInputs) => LocalizedString} */
const pl_admin_ai_chat_error = en_admin_ai_chat_error;

/** @type {(inputs: Admin_Ai_Chat_ErrorInputs) => LocalizedString} */
const hu_admin_ai_chat_error = en_admin_ai_chat_error;

/** @type {(inputs: Admin_Ai_Chat_ErrorInputs) => LocalizedString} */
const ro_admin_ai_chat_error = en_admin_ai_chat_error;

/**
* | output |
* | --- |
* | "Could not get a reply. Try again." |
*
* @param {Admin_Ai_Chat_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_error = /** @type {((inputs?: Admin_Ai_Chat_ErrorInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_ErrorInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_error(inputs)
	if (locale === "de") return de_admin_ai_chat_error(inputs)
	if (locale === "es") return es_admin_ai_chat_error(inputs)
	if (locale === "fr") return fr_admin_ai_chat_error(inputs)
	if (locale === "nl") return nl_admin_ai_chat_error(inputs)
	if (locale === "it") return it_admin_ai_chat_error(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_error(inputs)
	if (locale === "pl") return pl_admin_ai_chat_error(inputs)
	if (locale === "hu") return hu_admin_ai_chat_error(inputs)
	return ro_admin_ai_chat_error(inputs)
});
export { admin_ai_chat_error as "admin.ai_chat.error" }